export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1639_.fd02704a.jpg";